const module = {
  config: {
    name: 'data-pengguna',
    icon: 'ri-team-line',
    desc: 'Digunakan untuk mendaftarkan, menonaktifkan, dan mengatur hak akses pengguna dan master data di PMIS Infrastruktur II',
    group: 'Lainnya',
    layout: true
  },
  routes: [
    { name: 'users', label: 'Daftar Pengguna', icon: 'ri-skip-right-fill', path: '/users', component: () => import('./users.vue') },
    // { name: 'role-group', icon: null, path: '/role-group', component: () => import('./role-group.vue') },
    { name: 'role', icon: null, path: '/role', component: () => import('./role.vue') },
    { name: 'permissions', icon: null, path: '/permissions', component: () => import('./permissions.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/user-role/_index.js